export const Event = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="22" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M5 11H27" stroke="currentColor" stroke-width="2"/>
<path d="M21 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M11 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M10.7238 17.5587C10.2565 17.5587 9.87765 17.1799 9.87765 16.7126C9.87765 16.2452 10.2565 15.8664 10.7238 15.8664C11.1911 15.8664 11.57 16.2452 11.57 16.7126C11.57 17.1799 11.1911 17.5587 10.7238 17.5587Z" fill="currentColor" stroke="currentColor" stroke-width="1.15789"/>
</svg>`;
